"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeListFilters = exports.Events = exports.RangeType = void 0;
const utils_1 = require("../../../utils");
const types_1 = require("../types");
var RangeType;
(function (RangeType) {
    RangeType["lower"] = "lower";
    RangeType["upper"] = "upper";
})(RangeType = exports.RangeType || (exports.RangeType = {}));
exports.Events = {
    _namespace_: "events",
    async info() {
        const res = await this.call("events.info");
        return await getEventsInfo(res);
    },
    async list({ filters = {}, count = 10, order = types_1.ListOrderType.descending, } = {}) {
        const res = await this.call("events.list", new Map([
            [0, count],
            [1, order],
            [2, makeListFilters(filters)],
        ]));
        return await getEventsList(res);
    },
};
async function getEventsInfo(message) {
    var _a;
    const payload = message.getPayload();
    return {
        count: (message === null || message === void 0 ? void 0 : message.getContent().has(4)) ? (_a = message === null || message === void 0 ? void 0 : message.getPayload()) === null || _a === void 0 ? void 0 : _a.get(0) : 0,
        events: (await Promise.all(payload.get(1).map(async (eventType) => {
            return await (0, utils_1.getEventTypeNameFromIndices)(eventType);
        }))).filter(Boolean),
    };
}
async function getEventsList(message) {
    const result = {
        count: 0,
        events: [],
    };
    const decodedContent = message.getPayload();
    if (decodedContent) {
        result.count = decodedContent.get(0);
        const events = decodedContent.get(1);
        result.events = (await Promise.all(events.map(async (t) => {
            var _a;
            try {
                return Object.assign({ id: t.get(0), time: (_a = t.get(1)) === null || _a === void 0 ? void 0 : _a.value }, (await (0, utils_1.makeTxnData)(t.get(2))));
            }
            catch (e) {
                console.error("error parsing txn:", e);
            }
        }))).filter(Boolean);
    }
    return result;
}
function makeListFilters(filters) {
    const result = new Map();
    const { accounts, txnIdRange } = filters;
    if (accounts) {
        if (typeof accounts !== "string" && !Array.isArray(accounts))
            throw "type of filter.accounts must be a string or string[]";
        result.set(0, accounts);
    }
    if (txnIdRange) {
        result.set(3, (0, utils_1.makeRange)(txnIdRange));
    }
    return result;
}
exports.makeListFilters = makeListFilters;
